<template>
  <div class="foundingTeam">
    <aboutNav></aboutNav>
    <div class="team-bj">
      <img src="~img/about/team/team-bj2.png" alt="">
    </div>
    <!-- <div class="container">
      <div class="topTeam row">
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <img src="~img/about/team/czj.png" alt="">
          <div class="introduce">
            <div class="topIntro">
              <h3 class="name">岑自健</h3>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.001</div>
              </div>
            </div>
            <div class="declaration">方法论的方法总比困难多</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6">
          <img src="~img/about/team/lzf.png" alt="">
          <div class="introduce">
            <div class="topIntro">
              <h3 class="name">赖正福</h3>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.002</div>
              </div>
            </div>
            <div class="declaration">人行正道，福来福往</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6">
          <img src="~img/about/team/zj.png" alt="">
          <div class="introduce">
            <div class="topIntro">
              <h3 class="name">赵静</h3>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.003</div>
              </div>
            </div>
            <div class="declaration">过去不能改变，未来可以</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6">
          <img src="~img/about/team/xcc.png" alt="">
          <div class="introduce">
            <div class="topIntro">
              <h3 class="name">肖长春</h3>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.004</div>
              </div>
            </div>
            <div class="declaration">逢山开路，遇水架桥，使命必达</div>
          </div>
          <div class="hoverBox"></div>
        </div>
      </div>
      <div class="bottomTeam row">
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/dl.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">董  镭</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.005</div>
              </div>
            </div>
            <div class="btDeclaration">知行合一，成人达己</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/px.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">彭  欣</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.006</div>
              </div>
            </div>
            <div class="btDeclaration">淡然处之，一笑置之</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/zzm.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">赵为民</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.007</div>
              </div>
            </div>
            <div class="btDeclaration">万物互联，物商之道</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/yml.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">杨明来</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.008</div>
              </div>
            </div>
            <div class="btDeclaration">刀在石上磨，人在难中炼</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/dwg.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">刁伟国</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.009</div>
              </div>
            </div>
            <div class="btDeclaration">大道三千，我行我素，标新立异，更上层楼</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/qb.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">秦  波</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.010</div>
              </div>
            </div>
            <div class="btDeclaration">越努力就会越幸运</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/lbl.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">陆伯兰</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.011</div>
              </div>
            </div>
            <div class="btDeclaration">诚信做人，好好做事</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/hmg.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">霍满光</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.012</div>
              </div>
            </div>
            <div class="btDeclaration">严于律己，宽以待人</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/zyf.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">周泳锋</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.013</div>
              </div>
            </div>
            <div class="btDeclaration">以仁为本，共德共赢</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/zgr.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">郑国荣</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.014</div>
              </div>
            </div>
            <div class="btDeclaration">幸福是奋斗出来的</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/wsz.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">王素珍</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.015</div>
              </div>
            </div>
            <div class="btDeclaration">梦想在路上，奋斗正当时</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/slf.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">孙凌峰</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.016</div>
              </div>
            </div>
            <div class="btDeclaration">有志者，事竟成</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/gxf.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">关湘发</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.017</div>
              </div>
            </div>
            <div class="btDeclaration">大道至简，大同智赢</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/llp.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">刘丽萍</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.018</div>
              </div>
            </div>
            <div class="btDeclaration">志当存高远，路自脚下行</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/xhh.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">徐浩华</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.019</div>
              </div>
            </div>
            <div class="btDeclaration">活着便精彩！</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/wmf.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">伍敏丰</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.020</div>
              </div>
            </div>
            <div class="btDeclaration">不忘初心，牢记使命</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/yzj.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">余兆俊</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.021</div>
              </div>
            </div>
            <div class="btDeclaration">认真做事，踏实做人</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/gxp.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">龚小平</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.022</div>
              </div>
            </div>
            <div class="btDeclaration">有压力，但不会压垮；迷茫，但不会绝望</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/wth.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">吴庭华</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.023</div>
              </div>
            </div>
            <div class="btDeclaration">认真做好每一件事情，努力把握每一个机会</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/yxk.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">俞旭凯</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.024</div>
              </div>
            </div>
            <div class="btDeclaration">宁愿辛苦一阵子，不要辛苦一辈子</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/qzw.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">钱忠伟</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.025</div>
              </div>
            </div>
            <div class="btDeclaration"></div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/dw.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">董武</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.026</div>
              </div>
            </div>
            <div class="btDeclaration"></div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/zyz.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">邹远珍</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.027</div>
              </div>
            </div>
            <div class="btDeclaration">整合天下资源为己用，己用为众生</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/yhz.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">叶惠忠</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.028</div>
              </div>
            </div>
            <div class="btDeclaration">激情创业，诚信立业</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/pls.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">潘露丝</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.029</div>
              </div>
            </div>
            <div class="btDeclaration">每一步，都算数</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/zjj.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">郑俊杰</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.030</div>
              </div>
            </div>
            <div class="btDeclaration">多学多乐，少空话多工作</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/cfg.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">陈芳贵</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.031</div>
              </div>
            </div>
            <div class="btDeclaration">仰望星空，脚踏实地</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/lyb.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">蓝育彬</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.032</div>
              </div>
            </div>
            <div class="btDeclaration">专注专业，笃行创新</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
       <img class="companyLogo" src="~img/about/team/guangshengHD.jpg" alt="">
          <div class="lf"><img src="~img/about/team/chy.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">陈环宇</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.033</div>
              </div>
            </div>
            <div class="btDeclaration">感恩·妙用·尊勝</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/hsx.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">何省贤</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.034</div>
              </div>
            </div>
            <div class="btDeclaration">自动循环，共同发展</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/swb.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">粟文斌</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.035</div>
              </div>
            </div>
            <div class="btDeclaration">不忘初心，方得始终</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/wyl.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">王邑洛</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.036</div>
              </div>
            </div>
            <div class="btDeclaration">踏踏实实做好一件事</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/hhs.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">黄红少</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.037</div>
              </div>
            </div>
            <div class="btDeclaration">付出者收获，担当者成长</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/wj.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">王  军</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.038</div>
              </div>
            </div>
            <div class="btDeclaration">踏实做人，认真做事</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/cyh.jpg" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">陈业海</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.039</div>
              </div>
            </div>
            <div class="btDeclaration">前途似海，来日方长</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/fjm.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">傅金明</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.040</div>
              </div>
            </div>
            <div class="btDeclaration">努力，奋斗！</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/wlp.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">邬利平</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.041</div>
              </div>
            </div>
            <div class="btDeclaration">合智共赢</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/sf.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">孙峰</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.042</div>
              </div>
            </div>
            <div class="btDeclaration">人生意义在于有多少人因为你过的更好</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/ljb.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">李机斌</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.043</div>
              </div>
            </div>
            <div class="btDeclaration">人生意义在于创造价值</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/wxf.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">马明慧</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.044</div>
              </div>
            </div>
            <div class="btDeclaration">超越，源自捕捉趋势的眼光</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/hy.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">郝  瑛</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.045</div>
              </div>
            </div>
            <div class="btDeclaration">天行健，君子以自强不息</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/ljt.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">廖锦添</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.046</div>
              </div>
            </div>
            <div class="btDeclaration"></div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/ll.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">李  丽</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.047</div>
              </div>
            </div>
            <div class="btDeclaration">向上向善，知行合一</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/ohr.jpg" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">区浩然</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.048</div>
              </div>
            </div>
            <div class="btDeclaration">高维思路定能解决低维事</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/lxh.png" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">李雪华</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.049</div>
              </div>
            </div>
            <div class="btDeclaration">用爱心做事，用感恩的心做人</div>
          </div>
          <div class="hoverBox"></div>
        </div>
        <div class="item col-lg-3 col-md-6 col-sm-6 col-sm-6">
          <div class="lf"><img src="~img/about/team/ljl.jpg" alt=""></div>
          <div class="rt">
            <div class="btTop">
              <div class="name">刘俊林</div>
              <div class="identityBox">
                <div class="identity">联合创始股东</div>
                <div class="ranking">NO.050</div>
              </div>
            </div>
            <div class="btDeclaration">平安快乐，与正义同行。</div>
          </div>
          <div class="hoverBox"></div>
        </div>
      </div>
      <div class="detail">按入股先后排序</div>
    </div> -->
  </div>
</template>
<script>
  import aboutNav from "./aboutNav";
  export default {
    name: "foundingTeam",
    components:{
      aboutNav
    },
		created(){
			if(this.$route.query.name == 'why'){
				this.$nextTick(()=>{
          setTimeout(()=>{
            var height=document.getElementById('header').clientHeight
					  document.documentElement.scrollTop=height;//不需要加单位
          },10)
				})
			}
		},
  }
</script>
<style scoped lang="less">
  .foundingTeam{
    box-shadow: #eee 1px 3px 5px;
  }
  @media (min-width: 750px)  {
  .team-bj{
    width: 100%;
    img{
      display: block;
      margin: 0 auto;
      width: 50%;
    }
  }


			}
			@media (max-width: 750px)  {
  .team-bj{
    width: 100%;
    img{
      display: block;
      margin: 0 auto;
      width: 100%;
    }
  }
	}
  .container{
    .detail{
      width: 200px;
      border: 1px solid #ee8835;
      padding: 10px 0;
      text-align: center;
      margin: 0 auto;
      margin-top: 8%;
      border-radius: 15px;
      cursor: default;

    }
    .name{font-weight: bold;}
    .hoverBox{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1000;
      &:hover{
        background: rgba(238,123,29,0.5);
      }
    }
    padding: 6% 0;
    text-align: center;
    .bottomTeam{
      margin: 0;
      .item{
        padding: 0;
        display: flex;
        justify-content: left;
        align-items: center;
        .lf{
          width: 40%;
          img{
            width: 100%;
            height: 158px;
          }
        }
        .rt{
          width: 60%;
          .btDeclaration{
            font-size: 14px;
            padding: 0 10px;
          }
          .btTop{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .name{
              width: 40%;
              font-size: 18px;
              padding: 6px 0;
              border-right: 1px solid #5a5a5a;
            }
            .identityBox{
              width: 60%;
              .identity{
                font-size: 14px;
              }
            }

            .ranking{
              font-size: 18px;
            }
          }
        }

      }
    }
    .topTeam{
      margin: 0;
      .item{
        padding: 0;
        position: relative;
        img{
          width: 100%;
        }
        .introduce{
          .declaration{
            font-size: 16px;
            padding-top: 5px;
          }
          padding: 20px;
          .topIntro{
            display: flex;
            justify-content: left;
            align-items: center;
            .name{
              width: 46%;
              border-right: 1px solid #5a5a5a;
              margin: 0;
            }
            .identityBox{
              width: 54%;
              .ranking{
                font-size: 24px;
              }
            }
          }
        }

      }
    }
  }
.companyLogo{
  width: 270px;
  height: 158px;
}

</style>


// WEBPACK FOOTER //
// src/pages/about/foundingTeam.vue